var pt = pt || {};
pt.portoeditora = pt.portoeditora || {};
pt.blocografico.library = pt.blocografico.library || {};
pt.blocografico.library.form = pt.blocografico.library.form || {};
pt.blocografico.library.form.validator = pt.blocografico.library.form.validator || {};

pt.blocografico.library.form.validator = new (function () {
  function validateFields(formId, fields, callbackOnSuccess = () => {}, callbackOnError = () => {}, checkRecaptcha = true) {
    const errors = {};
    let firstInvalidField = null;

    const form = document.getElementById(formId);

    for (let field in fields) {
      const value = form.querySelector(`[name="${field}"]`).value;
      const rules = fields[field].rules;
      let hasError = false;

      for (const [rule, prop] of Object.entries(rules)) {
        switch (rule) {
          case "required":
            if (prop && !value) {
              errors[field] = `Campo obrigatório`;
              hasError = true;
            }
            break;
          case "minLength":
            if (prop && value.length < prop) {
              errors[field] = `Deve conter mais de ${prop} carateres`;
              hasError = true;
            }
            break;
          case "maxLength":
            if (prop && value.length > prop) {
              errors[field] = `Deve conter no máximo ${prop} carateres`;
              hasError = true;
            }
            break;
          case "email":
            if (prop && !pt.blocografico.library.form.validator.checkEmail(value)) {
              errors[field] = `Padrão inválido`;
              hasError = true;
            }
            break;
          case "customValidator":
            switch (prop) {
              case "email":
                if (!pt.blocografico.library.form.validator.checkEmail(value)) {
                  errors[field] = `Padrão inválido`;
                  hasError = true;
                }
                break;
              case "nif":
                if (!pt.blocografico.library.form.validator.checkNif(value)) {
                  errors[field] = `Padrão inválido`;
                  hasError = true;
                }
                break;
              case "phone":
                if (!pt.blocografico.library.form.validator.checkPhone(value)) {
                  errors[field] = `Padrão inválido`;
                  hasError = true;
                }
                break;
            }
            break;
        }
      }

      form.querySelector(`[name="${field}"]`).classList.remove("invalid");

      if (hasError) {
        form.querySelector(`[name="${field}"]`).classList.add("invalid");
        if (!firstInvalidField) {
          firstInvalidField = form.querySelector(`[name="${field}"]`);
          firstInvalidField.focus();
        }
      }
    }

    let recaptcha = form.querySelector(`.cf-turnstile`) || form.querySelector(`.g-recaptcha`);

    if (checkRecaptcha && recaptcha) {
      var token;
      if (recaptcha.classList.contains(`cf-turnstile`)) {
        token = turnstile.getResponse();
        recaptcha.style.border = token ? "0px" : "1px solid red";
      } else {
        token = grecaptcha.getResponse();
        form.querySelector(`.g-recaptcha div`).style.border = token ? "0px" : "1px solid red";
      }
      if (!token) {
        return;
      }
    }

    if (Object.keys(errors).length > 0) {
      return callbackOnError(errors);
    }

    callbackOnSuccess();
  }

  function validateSingleField(formId, fields, field) {
    const form = document.getElementById(formId);
    const value = form.querySelector(`[name="${field}"]`).value;
    const rules = fields[field].rules;
    let errors = {};
    let hasError = false;

    for (const [rule, prop] of Object.entries(rules)) {
      if (hasError) {
        break;
      }
      switch (rule) {
        case "required":
          if (prop && !value) {
            errors[field] = `Campo obrigatório`;
            hasError = true;
          }
          break;
        case "minLength":
          if (prop && value.length < prop) {
            errors[field] = `Deve conter mais de ${prop} carateres`;
            hasError = true;
          }
          break;
        case "maxLength":
          if (prop && value.length > prop) {
            errors[field] = `Deve conter no máximo ${prop} carateres`;
            hasError = true;
          }
          break;
        case "email":
          if (prop && !pt.blocografico.library.form.validator.checkEmail(value)) {
            errors[field] = `Padrão inválido`;
            hasError = true;
          }
          break;
        case "customValidator":
          switch (prop) {
            case "email":
              if (!pt.blocografico.library.form.validator.checkEmail(value)) {
                errors[field] = `Padrão inválido`;
                hasError = true;
              }
              break;
            case "nif":
              if (!pt.blocografico.library.form.validator.checkNif(value)) {
                errors[field] = `Padrão inválido`;
                hasError = true;
              }
              break;
            case "phone":
              if (!pt.blocografico.library.form.validator.checkPhone(value)) {
                errors[field] = `Padrão inválido`;
                hasError = true;
              }
              break;
          }
          break;
      }
    }

    form.querySelector(`[name="${field}"]`).parentElement.classList.remove("invalid");

    if (hasError) {
      form.querySelector(`[name="${field}"]`).parentElement.classList.add("invalid");
    }
  }

  function checkEmail(value) {
    var res = false;
    var reEMail = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.{1}[a-zA-Z]{2,4}$");
    var reComma = new RegExp(",+");
    var match1 = value.match(reEMail) != null;
    var match2 = value.match(reComma) != null;
    if ((match1 || value == "") && !match2) {
      res = true;
    }
    return res;
  }

  function checkNif(value) {
    let c;

    if (value.length != 9) {
      return false;
    }

    c = value.charAt(0);

    if (c == "0" || c == "8") {
      return false;
    }

    return algoritmoValidacaoNifPT(value);
  }

  function algoritmoValidacaoNifPT(numFormated) {
    var pos,
      ctl,
      val = 0;

    for (pos = 0; pos < 8; ++pos) {
      val += parseInt(numFormated.charAt(pos)) * (9 - pos);
    }

    ctl = 0;
    if (val % 11 != 0) {
      ctl = (11 - (val % 11)) % 10;
    }
    return ctl == parseInt(numFormated.charAt(8));
  }

  function checkPhone(value) {
    return /^9[1236]{1}[0-9]{7}$|^2[3-9]{2}[0-9]{6}$|^2[12]{1}[0-9]{7}$/.test(value);
  }

  return {
    validateFields: validateFields,
    validateSingleField: validateSingleField,
    checkEmail: checkEmail,
    checkNif: checkNif,
    checkPhone: checkPhone,
  };
})();
